export const allowedCharactersInComboBoxRegexPattern = /[^a-zA-Z0-9&(),.\s-]/g;

export const allowedCharactersInTextFieldRegexPattern = /[^a-zA-Z0-9.\s-]/g;
